/**
 * Helper to use mainly of switch statements,
 * while the given error is a bit cryptic it help us
 * control that all switch statement paths from enums
 * are handled.
 **/

export function assertNever(value: never, errorMessage?: string): never {
  if (typeof errorMessage === 'string') {
    throw new Error(errorMessage)
  }

  throw new Error('Unexpected value: ' + value)
}
